import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-16 bg-charcoal text-white" data-id="element-210">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-211">
        <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-gold/20 text-gold mb-6" data-id="element-212">
          <ShieldCheck className="w-10 h-10" data-id="element-213" />
        </div>

        <h2 className="text-3xl md:text-4xl font-serif font-bold mb-6" data-id="element-214">
          GARANTÍA 7 DÍAS — SIN PREGUNTAS
        </h2>

        <p className="text-xl text-gray-300 mb-6 leading-relaxed" data-id="element-215">
          Abrís los tomos. Aplicás los protocolos.
          <br data-id="element-216" />
          Si en 7 días no es lo que esperabas:
          <br data-id="element-217" />
          <span className="text-gold font-bold" data-id="element-218">
            devolución del 100% sin formularios, sin drama.
          </span>
        </p>

        <div className="inline-block border border-white/20 rounded-full px-6 py-2 text-sm text-gray-400" data-id="element-219">
          Tasa de devoluciones: menos del 1%.
        </div>
      </div>
    </section>;
}